var styles = {"divider":"HorizontalDivider-module_divider__p8rk5","withLine":"HorizontalDivider-module_withLine__i1h4b","withChildren":"HorizontalDivider-module_withChildren__u14qb"};

export { styles as default };
//# sourceMappingURL=HorizontalDivider.module.scss.js.map
